// Room labels for an accommodation, built from the real inventory fields the backend returns
// (residentialNumber/roomNumber and their pendingMove* counterparts) — never hardcoded numbers.
//
// A resident whose transfer has been approved but whose arrival is not yet confirmed carries
// pendingMove* fields; until arrival is confirmed we show "current → destination" and never the
// destination on its own. Once the move is confirmed the backend has already moved the
// accommodation to the destination room, so pendingMove* is empty and the current room shows it.
const roomLabel = (residentialNumber, roomNumber) => `${residentialNumber || "—"}-${roomNumber || "—"}`;

export const hasPendingMove = record => !!record?.pendingMoveRoomId;

export const currentRoomLabel = record => roomLabel(record?.residentialNumber, record?.roomNumber);

export const pendingRoomLabel = record =>
  roomLabel(record?.pendingMoveResidentialNumber, record?.pendingMoveRoomNumber);

export const accommodationRoomLabel = record =>
  hasPendingMove(record)
    ? `${currentRoomLabel(record)} → ${pendingRoomLabel(record)}`
    : currentRoomLabel(record);
